<template>
  <div class="game-container" :style="getMainGameSyle()">
    <div id="game-container"><canvas id="gameCanvas" :style="getStyle()"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixinV2';
import createjsMixin from '../../mixins/createjsMixinV2';
export default {
  name: 'mp-puzzle-v2',
  mixins: [defaultMixins, createjsMixin],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
      moved: 0,
      ticker: false,
      animation: false,
      movesTo: [],
      targets: [],
      corrects: [],
      clones: [],
      maxClone: 0,
      category: [],
      puzzle: [],
      solved: 0,
    };
  },
  beforeMount() {
    this.prototypeArray();
  },
  mounted() {
    // context.commit( 'RESET_GAME', false );
    this.ticker = createjs.Ticker;
    this.setDataGame();
    this.initGame();
    this.initPuzzle();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    initPuzzle() {
      var self = this;
      this.removeListeners();
      this.images.forEach(function (gr, i) {
        gr.forEach(function (cont, j) {
          if (cont.type == 'target') {
            cont.listener.c = cont.on('click', self.switchCategory);
            if (cont.visible === false) cont.isActive = true;
            else cont.isActive = false;
            cont.idx = { gr: i, i: j };
            if (i == 0 && j == 0) cont.visible = false;
            else if (i == 0 && j == 1) cont.visible = true;
            self.category.push(cont);
          } else {
            cont.listener.c = cont.on('click', self.clickPuzzle);
            self.puzzle.push(cont);
          }
        });
      });
    },
    switchCategory(e) {
      // this.resetCheckStatus();
      var click = e.currentTarget;
      if (click.isActive === false) {
        this.category.forEach(function (cont) {
          if (cont.isActive === true && cont.visible === true) {
            cont.visible = false;
          }
          if (cont.isActive === false && cont.visible === false) {
            cont.visible = true;
          }
          if (cont.idx.gr == click.idx.gr && cont.isActive === true) {
            cont.visible = true;
          }
          if (cont.idx.gr == click.idx.gr && cont.isActive === false) {
            cont.visible = false;
          }
        });
      }
    },
    clickPuzzle(e) {
      // this.resetCheckStatus();
      var click = e.currentTarget,
        active = false,
        self = this,
        isCorrect = false;
      this.category.forEach(function (cont) {
        if (cont.isActive === true && cont.visible === true) {
          active = {
            id: cont.id,
            gr: cont.idx.gr,
            i: cont.idx.i,
          };
        }
      });
      click.correct.forEach(function (cor) {
        if (cor.id == active.id) {
          click.visible = false;
          self.solved++;
          isCorrect = true;
        }
      });
      if (!isCorrect) {
        // this.$store.commit('CHANGE_BLOCK_CHECK_ACTION', false);
        // this.$store.commit('CHANGE_ACTUAL_GAME_STATUS_TO_INCORRECT');
        // this.$store.commit('CHECK_GAME', true);
        // this.$store.commit('CHANGE_CHECK_SWITCH', true);
        // this.$store.dispatch('checkGame', false);
        // this.$store.commit('CHANGE_CHECK_SWITCH', true);
      } else if (this.solved == this.puzzle.length) {
        // this.$store.commit('CHANGE_BLOCK_CHECK_ACTION', false);
        // this.$store.commit('CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT');
        // this.$store.commit('CHANGE_CHECK_SWITCH', true);
      }
    },
    tick(e) {
      this.stage.update(e);
    },
    resetGameAction() {
      this.newGame();
      this.category.splice(0, this.category.length);
      this.puzzle.splice(0, this.puzzle.length);
      this.solved = 0;
      this.initPuzzle();
    },
    checkGameAction() {},
    getMainGameSyle() {
      return _.merge({}, this.getCustomStyle(this.startGameConfig.mainGameSyle));
    },
    getStyle() {
      return _.merge({}, this.getCustomStyle(this.startGameConfig));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/fonts';
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
